if (!customElements.get('product-usps')) {
  class ProductUsps extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-usps-content]');
      this.toggle = this.querySelector('[data-usps-toggle]');
      if (!this.content) return;

      this.iconUrl = this.dataset.iconUrl;
      this.visibleItems = parseInt(this.dataset.visibleItems) || 3;

      this.enhanceList();
      this.setupCollapse();

      if (this.toggle) {
        this.toggle.addEventListener('click', () => this.toggleCollapse());
      }
    }

    enhanceList() {
      const allItems = this.content.querySelectorAll('li');
      let warningMode = false;

      allItems.forEach(li => {
        let prev = li.parentElement.previousElementSibling;
        while (prev) {
          if (prev.tagName === 'P' && /LET OP/i.test(prev.textContent)) {
            warningMode = true;
            prev.classList.add('product-usps__warning-text');
          }
          prev = prev.previousElementSibling;
        }

        li.classList.add('product-usps__item');

        if (warningMode) {
          li.parentElement.classList.add('product-usps__list', 'product-usps__list--plain');
          const dash = document.createElement('span');
          dash.className = 'product-usps__dash';
          dash.setAttribute('aria-hidden', 'true');
          dash.textContent = '\u2013';
          li.insertBefore(dash, li.firstChild);
        } else {
          li.parentElement.classList.add('product-usps__list');
          const img = document.createElement('img');
          img.className = 'product-usps__icon';
          img.src = this.iconUrl;
          img.width = 18;
          img.height = 18;
          img.alt = '';
          img.setAttribute('aria-hidden', 'true');
          li.insertBefore(img, li.firstChild);
        }
      });
    }

    setupCollapse() {
      const firstList = this.content.querySelector('.product-usps__list');
      if (!firstList) return;

      this.items = firstList.querySelectorAll('.product-usps__item');
      if (this.items.length <= this.visibleItems) {
        if (this.toggle) this.toggle.hidden = true;
        return;
      }

      // Hide items beyond visible count
      this.setCollapsed(true);
    }

    setCollapsed(collapsed) {
      this.items.forEach((item, i) => {
        if (i >= this.visibleItems) {
          item.hidden = collapsed;
        }
      });

      // Also hide/show any content after the first list (warnings, extra lists)
      const firstList = this.content.querySelector('.product-usps__list');
      let sibling = firstList.nextElementSibling;
      while (sibling) {
        sibling.hidden = collapsed;
        sibling = sibling.nextElementSibling;
      }

      this.content.classList.toggle('is-collapsed', collapsed);
    }

    toggleCollapse() {
      const isCollapsed = this.content.classList.contains('is-collapsed');
      this.setCollapsed(!isCollapsed);
    }
  }

  customElements.define('product-usps', ProductUsps);
}
